export const billConstant = {
    OPEN_BILL_DIALOG:'BILL_OPEN_BILL_DIALOG',
    CLOSE_BILL_DIALOG:'BILL_CLOSE_BILL_DIALOG',
}